import { createColumnHelper } from '@tanstack/table-core'
import { NA } from 'constans/common'
import { useMemo } from 'react'
import { Table, Text } from 'shared/components'
import DateTimeCell from 'shared/components/DateTimeCell'
import { GiftTransactionModel } from 'types/customers'

interface GiftExchangeHistoriesProps {
  data?: GiftTransactionModel[]
}

const GiftExchangeHistories = ({ data = [] }: GiftExchangeHistoriesProps) => {
  const columnsHelper = createColumnHelper<GiftTransactionModel>()
  const columns = useMemo(() => {
    return [
      columnsHelper.accessor('CreatedDate', {
        header: 'Ngày giao dịch',
        cell: row => <DateTimeCell value={row.getValue()} />,
      }),
      columnsHelper.accessor('TemQuantity', {
        header: 'Số lượng đã đổi',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
      columnsHelper.accessor('ProductName', {
        header: 'Quà đã đổi',
        cell: row => <Text>{row.getValue()}</Text>,
      }),
      columnsHelper.accessor('Address', {
        header: 'Cửa hàng đã đổi',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
    ]
  }, [columnsHelper])

  return <Table columns={columns} data={data || []} heading="Lịch sử đổi quà" />
}

export default GiftExchangeHistories
